import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import equipClassOptions from "../../_helpers/equipClasses";
import { ADR_EDIT } from "../../_constants/actionConstants";
import equipmentActions from "../../_actions/equipmentActions";

class AddEquipmentModalV3 extends Component {
  state = {
    formData: {
      contractorId: null,
      selectedContractor: null,
      number: "",
      make: "",
      model: "",
      isRental: false,
      selectedEquipClass: null,
      equipClass: "",
      description: "", // Same as equipment model
    },
    formErrors: {},
  };

  componentDidMount() {
    const { contractorId, contractorOptions } = this.props;
    const selectedContractor = contractorId
      ? contractorOptions.find((co) => co.value === contractorId)
      : null;
    if (contractorId)
      this.setState({
        formData: { ...this.state.formData, contractorId, selectedContractor },
      });
  }

  handleChange = (e) =>
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });

  handleChange_check = (e) =>
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.checked },
    });

  handleChange_select = (fieldName, optionFieldName) => (selectedOption) => {
    const formData = { ...this.state.formData };
    formData[fieldName] = selectedOption.value;
    formData[optionFieldName] = selectedOption;
    this.setState({ formData }, () => this.validateForm(fieldName));
  };

  handleBlur = (e) => this.validateForm(e.target.name);

  handleBlur_select = (fieldName) => () => this.validateForm(fieldName);

  formIsIncomplete = () => {
    const { formData, formErrors } = this.state;
    return (
      !formData.contractorId ||
      !formData.number ||
      !formData.equipClass ||
      !formData.model ||
      !formData.make ||
      ("contractor" in formErrors && formErrors.contractor) ||
      ("number" in formErrors && formErrors.number) ||
      ("equipClass" in formErrors && formErrors.equipClass) ||
      ("make" in formErrors && formErrors.make) ||
      ("model" in formErrors && formErrors.model)
    );
  };

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "contractorId":
        if (formData.selectedContractor === null) formErrors.contractor = "Required";
        else formErrors.contractor = null;
        break;
      case "number":
        if (!formData.number) formErrors.number = "Required";
        else formErrors.number = null;
        break;
      case "equipClass":
        if (!formData.equipClass) formErrors.equipClass = "Required";
        else formErrors.equipClass = null;
        break;
      case "make":
        if (!formData.make) formErrors.make = "Required";
        else formErrors.make = null;
        break;
      case "model":
        if (!formData.model) formErrors.model = "Required";
        else formErrors.model = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  handleSubmit = async (e) => {
    const {
      dispatch,
      projectId,
      tabId,
      rowKey,
      toggleAddEquipmentModal,
      user,
      markAdrDirty,
    } = this.props;
    const { formData } = this.state;
    e.preventDefault();

    if (!this.formIsIncomplete()) {
      const equipmentToAdd = {
        ...formData,
        projectId,
        addedByUserId: user.userId,
      };

      const newEquipment = await dispatch(equipmentActions.add(equipmentToAdd));
      dispatch({
        type: ADR_EDIT.EQUIPMENTSET.UPDATE,
        tabId,
        rowKey,
        fields: {
          contractorId: newEquipment.contractorId,
          equipmentId: newEquipment.equipmentId,
        },
      });
      toggleAddEquipmentModal();
      markAdrDirty();
    }
  };

  render() {
    const { formData, formErrors } = this.state;
    const { showAddEquipmentModal, toggleAddEquipmentModal, contractorOptions } =
      this.props;

    const closeBtn = (
      <button className="close" onClick={toggleAddEquipmentModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );

    return (
      <Modal
        isOpen={showAddEquipmentModal}
        toggle={toggleAddEquipmentModal}
        className={this.props.className}
        fade={false}
        size={"lg"}
      >
        <ModalHeader
          toggle={toggleAddEquipmentModal}
          className="bg-info text-white"
          close={closeBtn}
        >
          <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
          Add New Equipment
        </ModalHeader>
        <ModalBody>
          <form id="addEquipForm" onSubmit={this.handleSubmit} autoComplete="off">
            <div className="card mx-2 mb-2 bg-lightgray">
              <div className="card-body">
                <div className="form-row form-group mb-0">
                  <label className="col-sm-3 col-form-label">
                    <b>Contractor:</b>*
                  </label>
                  <div className="col-sm-6 my-auto">
                    <Select
                      name="contractorId"
                      id="contractorId"
                      value={formData.selectedContractor}
                      options={contractorOptions ? contractorOptions : []}
                      onChange={this.handleChange_select(
                        "contractorId",
                        "selectedContractor"
                      )}
                      placeholder="(Select a Contractor)"
                    />
                    {formErrors.contractor && (
                      <span className="error-small">
                        <small>{formErrors.contractor}</small>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="card mx-2 mb-2">
              <div className="card-body">
                <div className="form-row form-group mb-3">
                  <label htmlFor="number" className="col-sm-3 col-form-label">
                    <b>Equipment No.:</b>*
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      name="number"
                      id="number"
                      className="form-control"
                      value={formData.number}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      disabled={formData.selectedContractor === null}
                    />
                    <span className="my-0 py-0 mr-2">
                      <small>If more than one, separate by comma.</small>
                    </span>
                    {formErrors.number && (
                      <span className="error-small">
                        <small>{formErrors.number}</small>
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-row form-group">
                  <label htmlFor="equipClass" className="col-sm-3 col-form-label">
                    <b>Class:</b>*
                  </label>
                  <div className="col-sm-9">
                    <Select
                      name="equipClass"
                      id="equipClass"
                      value={formData.selectedType}
                      options={equipClassOptions}
                      onChange={this.handleChange_select(
                        "equipClass",
                        "selectedEquipClass"
                      )}
                      onBlur={this.handleBlur_select("equipClass")}
                      isDisabled={formData.selectedContractor === null}
                      styles={{
                        // Fixes the overlapping problem of the component
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                    />
                    {formErrors.equipClass && (
                      <span className="error-small">
                        <small>{formErrors.equipClass}</small>
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-row form-group">
                  <label htmlFor="make" className="col-sm-3 col-form-label">
                    <b>Make:</b>*
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      name="make"
                      id="make"
                      className="form-control"
                      value={formData.make}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      autoComplete="off"
                      disabled={formData.selectedContractor === null}
                    />
                    {formErrors.make && (
                      <span className="error-small">
                        <small>{formErrors.make}</small>
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-row form-group">
                  <label htmlFor="model" className="col-sm-3 col-form-label">
                    <b>Model:</b>*
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      name="model"
                      id="model"
                      className="form-control"
                      value={formData.model}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      autoComplete="off"
                      disabled={formData.selectedContractor === null}
                    />
                    {formErrors.model && (
                      <span className="error-small">
                        <small>{formErrors.model}</small>
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-row form-group">
                  <label htmlFor="description" className="col-sm-3 col-form-label">
                    Description:
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      name="description"
                      id="description"
                      className="form-control"
                      value={formData.description}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      autoComplete="off"
                      disabled={formData.selectedContractor === null}
                    />
                    {formErrors.description && (
                      <span className="error-small">
                        <small>{formErrors.description}</small>
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-row mb-0">
                  <div className="col-sm-3"></div>
                  <div className="col-sm-9">
                    <div className="custom-control-inline custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name="isRental"
                        id="isRental"
                        className="custom-control-input my-auto ml-2"
                        disabled={formData.selectedContractor === null}
                        value={formData.isRental}
                        checked={formData.isRental}
                        onChange={this.handleChange_check}
                      />
                      <label htmlFor="isRental" className="custom-control-label my-auto">
                        This is a rental equipment
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ml-2">
              <small>* indicates required fields</small>
            </div>
          </form>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group">
            <span className="mr-3 my-auto">
              <small>
                Further equipment details can be input/edited in the Equipment edit
                screen.
              </small>
            </span>
            <input
              className="btn btn-primary"
              name="addEquip"
              type="submit"
              form="addEquipForm"
              onClick={this.handleSubmit}
              value="Add"
              disabled={this.formIsIncomplete()}
            />
            <button
              className="btn btn-secondary ml-2"
              color="secondary"
              onClick={toggleAddEquipmentModal}
            >
              Cancel
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
});

export default connect(mapStateToProps)(AddEquipmentModalV3);
